<template>
  <div class="customer__form modal modal--default">
    <div class="modal__panel modal__panel--sales">
      <div class="modal__logo-wrapper">
        <div class="modal__logo"></div>
        <!-- <div class="modal__logo-title">Seguro Desk</div> -->
      </div>

      <div class="modal__main-icon modal__main-icon--setting"></div>
      <div class="modal__close" @click="closeModal()"></div>

      <div class="form">
        <div class="navigators">
          <div class="navigator navigator--active">
            <div class="navigator__bullet"></div>
            <div class="navigator__title">{{ $t(`addSaleCategoryCompanyModal.${"title"}`) }}</div>
          </div>
        </div>
        <div class="add__form">
          <transition name="fade" mode="out-in">
            <Loading v-if="formLoading" />
            <div v-else class="add__content">
              <div class="form__field">
                <VSelect class="select select--default" :class="{ 'select--error': companyHasError }"
                  :options="companies" :reduce="(company) => company.id" v-model="companyId" label="name"
                  :placeholder="$t(`addSaleCategoryCompanyModal.${'companyPlaceholder'}`)" />
                <div class="form__error" v-if="companyHasError">
                  {{ $t(`addSaleCategoryCompanyModal.${"companyErrorMsg"}`) }}
                </div>
              </div>
              <div class="form__field">
                <input type="text" class="input input--default" :class="{ 'input--error': provisionHasError }"
                  :placeholder="$t(`addSaleCategoryCompanyModal.${'provisionPlaceholder'}`)" v-model="provision" />
                <div class="form__error" v-if="provisionHasError">
                  {{ $t(`addSaleCategoryCompanyModal.${"provisionErrorMsg"}`) }}
                </div>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div v-if="isRequesting" class="modal__button modal__button--submit button button--default button--loading"></div>
      <button v-else class="modal__button modal__button--submit button button--default"
        @click="addSaleCategoryPriceCompany()">
        <span>{{ $t(`addSaleCategoryCompanyModal.${"addBtn"}`) }}</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue";
import { useStore } from "vuex";
import Loading from "@/partials/Loading";
import eventBus from "@/eventBus";

defineOptions({
  name: "AddSaleCategoryCompanyModal"
});

const store = useStore();

// Reactive State (Replaces data)
const formLoading = ref(false);
const title = ref("");
const provision = ref("");
const companyId = ref("");
const isRequesting = ref(false);

const titleHasError = ref(false);
const provisionHasError = ref(false);
const companyHasError = ref(false);

// Computed Properties (Replaces mapGetters and computed)
const salesCategoryPriceCompaniesData = computed(() => store.getters.salesCategoryPriceCompaniesData);
const saleCategoryPriceId = computed(() => store.getters.saleCategoryPriceId);

// Derived Computed States
const companies = computed(() => {
  return salesCategoryPriceCompaniesData.value?.companies || [];
});

// Validation Methods
const validateProvision = () => {
  let decimalProvision = "";
  if (provision.value && provision.value.includes(".")) {
    decimalProvision = provision.value.split(".")[1];
  }

  if (
    provision.value &&
    provision.value <= 100 &&
    provision.value >= 0 &&
    decimalProvision.length <= 4
  ) {
    provisionHasError.value = false;
  } else {
    provisionHasError.value = true;
  }
};

const validateTitle = () => {
  if (!title.value) {
    titleHasError.value = true;
  } else {
    titleHasError.value = false;
  }
};

const validateCompany = () => {
  if (!companyId.value) {
    companyHasError.value = true;
  } else {
    companyHasError.value = false;
  }
};

// Component Action Methods
const closeModal = () => {
  store.commit("setShowAddSaleCategoryCompanyModal", false);
};

const addSaleCategoryPriceCompany = async () => {
  isRequesting.value = true;
  validateProvision();
  validateCompany();

  if (!provisionHasError.value && !companyHasError.value) {
    await store.dispatch("addSaleCategoryPriceCompany", {
      companyId: companyId.value,
      provision: provision.value,
      salesCategoryPriceId: saleCategoryPriceId.value,
    });

    eventBus.emit("priceCompanyAdded");
    closeModal();
  }
  isRequesting.value = false;
};

// Watchers (Replaces watch)
watch(title, () => {
  validateTitle();
});

watch(provision, () => {
  validateProvision();
});

watch(companyId, () => {
  validateCompany();
});

// Initialization Logic (Replaces created)
const initComponent = async () => {
  formLoading.value = true;
  await store.dispatch("getSaleCategoryCompanies", saleCategoryPriceId.value);
  formLoading.value = false;
};

initComponent();
</script>

<style scoped lang="scss">
.modal__button {
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
}

.add {
  &__form {
    width: 100% !important;
  }
}

.form__field {
  width: 280px !important;
  margin: 20px auto;
}

.modal__panel--sales {
  height: 450px;
}
</style>
